import { getData, setData } from '@lib/storage';

import { client } from './client';
import { endpoints } from './endpoints';

export async function refreshAccessToken(): Promise<string> {
  const refreshToken = await getData('refreshToken');

  if (!refreshToken) {
    throw new Error('No refresh token');
  }

  const res = await client.put(
    endpoints.REFRESH_AUTH_URL,
    { refreshToken },
    {
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
      },
    },
  );

  await Promise.all([
    setData('accessToken', res.data.accessToken),
    setData('refreshToken', res.data.refreshToken),
  ]);

  return res.data.accessToken;
}
